/**
 * Queue-full display state — operator fix, narcis_funnel step 5 follow-up (2026-07-25,
 * DEVIATIONS.md #44). The pack page's own "+ Queue this pack for your model" B-ghost and its
 * C-state main CTA (`PackLandingTemplate.tsx`) called `usePackQueue.queuePack` directly with no
 * cap awareness. At `PACK_QUEUE_CAP` the server's atomic `INSERT … HAVING` guard
 * (`packQueue.server.ts`) correctly refuses, but the button gave zero feedback — clicking it
 * silently did nothing. The hub grid's own queue button (`_layout.packs.tsx`'s `queueActionFor`)
 * already read `usePackQueue.isFull` and disabled itself with a "Queue full" label; this module is
 * the single source of truth for the "is it full" predicate and the "full" copy, now shared by
 * both surfaces. Operator copy canon: middot, never an em dash.
 *
 * Cap is passed in, not imported — the three copies of the literal `3`
 * (`packQueue.server.ts`'s `PACK_QUEUE_CAP`, `anonPackQueue.ts`'s `ANON_QUEUE_CAP`, this module's
 * callers) are kept deliberately separate across the client/server boundary; see those two
 * modules' own header comments for why.
 */

/** Whether a queue of `queueLength` entries has no room for one more, given `cap`. */
export function isQueueFull(queueLength: number, cap: number): boolean {
    return queueLength >= cap
}

/** "Queue full · 3 of 3" — operator copy canon, no em dash. */
export function queueFullLabel(cap: number): string {
    return `Queue full · ${cap} of ${cap}`
}
